import React from 'react';

import { SynchronizeArrowsWarning } from 'src/app/components/icons/synchronize-arrows-warning';

import { LabelWithWarning } from './styled';

export function LabelWithWarningIcon({ label }: { label: string }) {
  return (
    <LabelWithWarning>
      {label}:<SynchronizeArrowsWarning size={16} />
    </LabelWithWarning>
  );
}
